<template>
  <div class="p-4 md:p-[50px] lg:p-[100px] flex flex-col gap-8 md:gap-[50px]">
    <section class="text-center">
      <h1 class="text-[24px] md:text-[32px] lg:text-[36px] font-semibold">
        {{ getLocalized(contentData, "title") }}
      </h1>
      <p class="text-[16px] lg:text-[24px] mt-4">
        {{ getLocalized(contentData, "description") }}
      </p>
    </section>

    <!-- FAQ Component -->
    <div class="space-y-4">
      <details
        v-for="(faq, index) in faqs"
        :key="index"
        class="group rounded-lg bg-white p-6 [&_summary::-webkit-details-marker]:hidden"
      >
        <summary
          class="flex cursor-pointer items-center justify-between gap-1.5 text-gray-900"
        >
          <h2 class="font-bold text-16px md:text-[18px] lg:text-[20px]">
            {{ getLocalized(faq, "question") }}
          </h2>

          <svg
            class="size-5 shrink-0 transition duration-300 group-open:-rotate-180"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </summary>

        <p
          class="mt-4 text-16px md:text-[18px] lg:text-[20px] leading-relaxed text-[#303030]"
        >
          {{ getLocalized(faq, "answer") }}
        </p>
      </details>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { useLocalization } from "@/composable/useLocalization";
import { fetchContentSection } from "@/composable/apiService";

export default {
  mounted() {
    this.fetchFaq();
  },
  computed: {
    // Optionally, you can use a computed property for localization logic
    getLocalized() {
      const { getLocalized } = useLocalization();
      return getLocalized;
    },
  },
  data() {
    return {
      faqs: [],
      api: process.env.VUE_APP_API_KEY,
      contentData: {},
      // Default language is from localStorage or 'en' if not set
      currentLang: localStorage.getItem("language") || "en",
    };
  },
  methods: {
    async fetchFaq() {
      try {
        this.contentData = await fetchContentSection(5);
        const response = await axios.get(
          this.api + "/api/faqs/?page=1&page_size=10"
        );
        this.faqs = response.data.items;
      } catch (e) {
        console.error(e.message);
      }
    },
  },
};
</script>
